module.exports = __webpack_public_path__ + "img/scibot.fdb5dc5f.jpg";